import { ConfigProvider } from "antd";
import { RootStore } from "../store";

const Provider = ({
  children
}) => /*#__PURE__*/React.createElement(ConfigProvider, {
  prefixCls: process.env.ANTD_PREFIX
}, /*#__PURE__*/React.createElement(RootStore.StoreProvider, null, children));

export { Provider };